import { createBrowserRouter, createMemoryRouter, Navigate, type RouteObject } from 'react-router';

import { AuditPage } from '../pages/audit/AuditPage';
import { PracticesPage } from '../pages/practices/PracticesPage';
import { UserCardPage } from '../pages/users/UserCardPage';
import { UsersListPage } from '../pages/users/UsersListPage';
import { YogaStylesPage } from '../pages/yoga-styles/YogaStylesPage';
import { SessionGate } from './SessionGate';
import { Shell } from './Shell';

/**
 * Дерево маршрутов — одно на приложение и на тесты. Приложение поднимает его в браузерном
 * роутере (у панели есть URL, в отличие от Mini App); тесты — в памяти, с нужным адресом.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <SessionGate />,
    children: [
      {
        element: <Shell />,
        children: [
          { index: true, element: <Navigate to="/users" replace /> },
          { path: 'users', element: <UsersListPage /> },
          { path: 'users/:userId', element: <UserCardPage /> },
          { path: 'practices', element: <PracticesPage /> },
          { path: 'yoga-styles', element: <YogaStylesPage /> },
          { path: 'audit', element: <AuditPage /> },
        ],
      },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes);
}

export function createTestRouter(initialEntries: string[]) {
  return createMemoryRouter(routes, { initialEntries });
}
